import { c as _c } from "react/compiler-runtime";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactElement } from 'react';
interface HeaderLinkAccordionProps {
  label: string;
  url?: string;
  expanded?: boolean;
  onAccordionChange?: (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  subLinks?: Array<{
    url: string;
    label: string;
  }>;
  onClose: () => void;
}
export function HeaderLinkAccordion(t0) {
  const $ = _c(33);
  const {
    label,
    url,
    expanded,
    onAccordionChange,
    subLinks,
    onClose
  } = t0;
  if (!subLinks?.length) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        alignItems: "flex-end",
        pr: 8
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        color: "text.secondary",
        fontSize: {
          xs: 30,
          sm: 38
        }
      };
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== label || $[3] !== onClose || $[4] !== url) {
      t3 = <Stack sx={t1}><MuiLink variant="h5" href={url} underline="none" rel="noopener" onClick={onClose} sx={t2}>{label}</MuiLink></Stack>;
      $[2] = label;
      $[3] = onClose;
      $[4] = url;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      pr: 8,
      "&::after": {
        content: "\"\"",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "100%",
        width: "100vw",
        backgroundColor: "background.default"
      }
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== label || $[8] !== onAccordionChange) {
    t2 = onAccordionChange?.(label);
    $[7] = label;
    $[8] = onAccordionChange;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "&:before": {
        display: "none"
      },
      backgroundColor: "transparent"
    };
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = `${label}-content`;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minHeight: "0 !important",
      padding: 0,
      "& .MuiAccordionSummary-content": {
        justifyContent: "flex-end",
        margin: "0 !important"
      }
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      xs: 30,
      sm: 38
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontSize: t6,
      color: "text.secondary",
      "&:hover": {
        color: "primary.main"
      }
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== label) {
    t8 = <Typography variant="h5" sx={t7}>{label}</Typography>;
    $[14] = label;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t8) {
    t9 = <AccordionSummary expandIcon={null} aria-controls={t4} sx={t5}>{t8}</AccordionSummary>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      my: 5,
      px: 0,
      py: 4,
      backgroundColor: "#F5F4ED",
      "&::after": {
        content: "\"\"",
        position: "absolute",
        top: {
          xs: 55,
          sm: 66.5
        },
        bottom: 20,
        left: "100%",
        width: "100vw",
        backgroundColor: "#F5F4ED",
        zIndex: 1
      }
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      alignItems: "flex-end",
      gap: {
        xs: 4,
        sm: 3
      }
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== onClose || $[22] !== subLinks) {
    let t13;
    if ($[24] !== onClose) {
      t13 = subLink => <MuiLink variant="h5" key={subLink.label} href={subLink.url} underline="none" rel="noopener" onClick={onClose} sx={{
        color: "text.secondary",
        fontSize: {
          xs: 22,
          sm: 27
        },
        "&:hover": {
          color: "primary.main"
        }
      }}>{subLink.label}</MuiLink>;
      $[24] = onClose;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    t12 = subLinks.map(t13);
    $[21] = onClose;
    $[22] = subLinks;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <AccordionDetails sx={t10}><Stack sx={t11}>{t12}</Stack></AccordionDetails>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== expanded || $[29] !== t13 || $[30] !== t2 || $[31] !== t9) {
    t14 = <Box sx={t1}><Accordion expanded={expanded} onChange={t2} elevation={0} disableGutters={true} sx={t3}>{t9}{t13}</Accordion></Box>;
    $[28] = expanded;
    $[29] = t13;
    $[30] = t2;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}